// frontend/src/api/fileIntegrationService.js
import { auth } from '../utils/firebase';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

async function getToken() {
  const user = auth.currentUser;
  if (!user) throw new Error('Not authenticated');
  return user.getIdToken();
}

export async function analyseFile(salonId, file) {
  const token = await getToken();
  const form = new FormData();
  form.append('salonId', salonId);
  form.append('file', file);
  const res = await fetch(`${API_BASE_URL}/api/file-integration/analyse`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: form,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Analysis failed');
  }
  return res.json();
}

export async function previewIngest(salonId, rows, mapping, matchKeys) {
  const token = await getToken();
  const res = await fetch(`${API_BASE_URL}/api/file-integration/preview`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ salonId, rows, mapping, matchKeys }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Preview failed');
  }
  return res.json();
}

export async function executeIngest(salonId, rows, mapping, matchKeys, scheduleName) {
  const token = await getToken();
  const res = await fetch(`${API_BASE_URL}/api/file-integration/ingest`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ salonId, rows, mapping, matchKeys, scheduleName }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Ingest failed');
  }
  return res.json();
}

export async function analyseFileUrl(salonId, fileUrl) {
  const token = await getToken();
  const res = await fetch(`${API_BASE_URL}/api/file-integration/analyse-url`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ salonId, fileUrl }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'URL analysis failed');
  }
  return res.json();
}

export async function saveSchedule(salonId, scheduleConfig) {
  const token = await getToken();
  const res = await fetch(`${API_BASE_URL}/api/file-integration/schedule/save`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ salonId, ...scheduleConfig }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Save schedule failed');
  }
  return res.json();
}

export async function listSchedules(salonId) {
  const token = await getToken();
  const res = await fetch(`${API_BASE_URL}/api/file-integration/schedule/list?salonId=${salonId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return { schedules: [] };
  return res.json();
}

export async function rollbackIngest(salonId, snapshotId) {
  const token = await getToken();
  const res = await fetch(`${API_BASE_URL}/api/file-integration/rollback`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ salonId, snapshotId }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'Rollback failed');
  }
  return res.json();
}

export async function getHistory(salonId) {
  const token = await getToken();
  const res = await fetch(`${API_BASE_URL}/api/file-integration/history?salonId=${salonId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return { history: [] };
  return res.json();
}
